
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getCompleteDataArrayInTimeRange","getAxisMinTimestamp","getSeriesFeaturesDataForEcharts","getSeriesGroupDataForEcharts","getDatasetFeaturesDataForEcharts","getSortedFeaturesValuesByProperty","getGroupedValuesByProperty","getGroupedValuesByTimeBucket","getGroupedValuesByPropertySplitByProperty","getGroupedValuesByTimeBucketSplitByProperty"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "3f99d013383c77cba880.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			